import { Provider } from '@angular/core';

import { AuthDataHttpService } from './abstract';
import { AuthDataHttpServiceImpl } from './auth-data-http.service';

export const AuthDataHttpProvider: Provider = {
	provide: AuthDataHttpService,
	useClass: AuthDataHttpServiceImpl,
};
